import { FC } from 'react';
import StakeholdersContext from './StakeholdersContext';

const StakeholdersLayout: FC = () => {
  return <StakeholdersContext />;
};

export default StakeholdersLayout;
